import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import MultiColumnBrowserContainer from "../../../controls/MultiColumnBrowser/MultiColumnBrowserContainer.mjs";
import MultiColumnBrowserColumn from "../../../controls/MultiColumnBrowser/MultiColumnBrowserColumn.mjs";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import appLib from "../../../libs/appLib.mjs";
import MyAccordion from "../../../controls/MyAccordion/MyAccordion.mjs";
import {Button, Table} from "reactstrap";
import AppPalleIcon from "../../../media/app-images/AppPalleIcon.mjs";
import SimulationFlowSettings2Modal from "./SimulationFlowSettings2Modal.mjs";
import AppFlagFalseIcon from "../../../media/app-images/AppFlagFalseIcon.mjs";
import FullScreenModal from "../../../controls/FullScreen/FullScreenModal.mjs";
import AppSynthDataIcon from "../../../media/app-images/AppSynthDataIcon.mjs";
import AppPerimeterIcon from "../../../media/app-images/AppPerimeterIcon.mjs";
import SimulationFlowSettings2CvesModal from "./SimulationFlowSettings2CvesModal.mjs";
import PeriGraphic from "../../../ComponentParts/Perimeters/PeriGraphic.mjs";

const MyCart = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: Object.values(props.data||{}).sort((a, b) => b.cve.localeCompare(a.cve) ),
		}
		this.onClick = this.onClick.bind(this);
	}
	onClick( x ) {
		if ( typeof this.props.onClick === 'function' ) this.props.onClick( x );
	}
	render() {
		if ( ! this.state.data.length ) return null;
		return (
			<div className={"MyCart MyCart2"}>
				<Table striped>
					<thead>
					<tr>
						<th>
							<TextLabel value={"CVE"} />
						</th>
						<th>
							<TextLabel value={"Main subject"} />
						</th>
						<th>
							<TextLabel value={"Resource"} />
						</th>
						<th><TextLabel value={"Scope"} /></th>
					</tr>
					</thead>
					<tbody>
					{ this.state.data.map( b => (
						<tr
							key={ b.cve }
							style={ this.props.onClick ? {cursor: "pointer"} : undefined}
							onClick={ () => this.onClick( b.cve ) }
						>
							<td>
								{ b.cve.toUpperCase() }
							</td>
							<td>
								{ b.subjectLabel }
							</td>
							<td>
								{ b.risorsaLabel }
							</td>
							<td>
								{ b.scope }
							</td>
						</tr>
					)) }
					</tbody>
				</Table>
			</div>
		)
	}
}

const prefix = "SimulationFlowSettings2";

/**
 * @typedef CartItem
 * @private
 * @type {Object}
 * @property {string} cve
 * @property {string} scope
 * @property {string} subject
 * @property {string} subjectLabel
 * @property {string} risorsa
 * @property {string} risorsaLabel
 * @property {number} score
 * @property {boolean} [new]
 */

const SimulationFlowSettings2 = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			update: Date.now(),
			/** @type {Record<string,CartItem>} */
			cart: structuredClone(props.simul?.trigger?.saved ?? {})
		};
		const inCart = {};
		Object.values( this.state.cart ).forEach( c => {
			inCart[ c.risorsa ] = true;
		});
		this.state.inCart = inCart;
		this.uid = Glob.generateUid(prefix);
		this.fetchSubjects = this.fetchSubjects.bind(this);
		this.fetchRisorse = this.fetchRisorse.bind(this);
		this.selectedRisorsa = this.selectedRisorsa.bind(this);
		this.selectedCve = this.selectedCve.bind(this);
		this.add2cart = this.add2cart.bind(this);
		this.openSelector = this.openSelector.bind(this);
		this.selectCve = this.selectCve.bind(this);
	}

	componentDidMount() {
		setTimeout( this.fetchSubjects )
	}

	fetchSubjects() {
		appLib.api('perimetri/list-subjects', {id: this.props.peri }).then( x => {
			const subjects = (x.result||[]).map( s => ({ label: s.name, value: s.id }));
			this.setState({ subjects: subjects });
		}).catch( err => {
			console.error( err );
		});
	}

	fetchRisorse(o){
		this.setState({ selectedRisorsa: false, selectedCve: false }, ()=>{
			const ss = o?.value ?? o;
			const ns = { risorse: [], selectedSubject: ss, };
			if ( ! ss ) {
				this.setState(ns);
				return;
			}
			appLib.api('perimetri/list-risorse', {id: this.props.peri, subject: ss }).then( x => {
				ns.risorse = (x.result||[]).map( s => ({ label: s.name, value: s.id }));
				this.setState(ns);
			}).catch( err => {
				console.error( err );
			});
		});
	}

	selectedRisorsa(o){
		this.setState({ cves: false, selectedRisorsa: false}, ()=>{
			const sr = o?.value ?? o;
			const ns = { cves: false, selectedRisorsa: sr };
			if ( ! sr ) {
				this.setState(ns);
				return;
			}
			ns.cves = [{ label: Glob.label('No items found'), value: 0, disabled: true}];
			appLib.api('simul/risorsa-uc2', {periID: this.props.peri, risorsaID: sr }).then( x => {
				if ( (x.cves||[]).length) ns.cves = (x.cves||[]).map( c => ({
					label: `[${String(.00001 + Math.round(c.finalScore * 1000 ) / 1000).replace(/([^0-9][0-9]{3}).*$/,"$1")}] ${c.cve}`,
					value: c.cve,
					icon: !! this.state.cart[ c.cve ] ? <AppFlagFalseIcon /> : <span style={{opacity: String(c.finalScore / 10)}}>🔴</span>,
					title: `Score: ${ c.finalScore } (impactScore: ${c.impactScore}, baseScore: ${c.baseScore})`,
					disabled: !! this.state.cart[ c.cve ],
					src: c
				}));
				this.setState(ns);
			}).catch( err => {
				console.error( err );
			});
		});
	}
	selectCve( resId ) {
		if ( ! resId ) return null;
		const nodeType = this.state.triggersUc2[resId];
		if ( ! nodeType ) return null;
		let uri;
		switch ( nodeType ) {
			case 'Risorsa' : uri = "simul/risorsa-uc2"; break;
			case 'SistemaInformativo' : uri = "simul/sistemi-informativi-uc2"; break;
			default: break;
		}
		if ( ! uri ) return null;
		appLib.api( uri, { peri: this.props.peri, id: resId }).then( x => {
			const cves = x.cves || [];
			if ( ! cves.length ) {
				window.alert(Glob.label('No items found'));
				return null;
			}
			const outCves = x.cves.map( c => ({
				label: `[${String(.00001 + Math.round(c.finalScore * 1000 ) / 1000).replace(/([^0-9][0-9]{3}).*$/,"$1")}] ${c.cve}`,
				value: c.cve,
				icon: !! this.state.cart[ c.cve ] ? <AppFlagFalseIcon /> : <span style={{opacity: String(c.finalScore / 10)}}>🔴</span>,
				title: `Score: ${ c.finalScore } (impactScore: ${c.impactScore}, baseScore: ${c.baseScore})`,
				disabled: !! this.state.cart[ c.cve ],
				src: c
			}));
			this.setState({ cvesModalSelector: true, cvesModal: outCves, cvesModalSource: resId });
		}).catch( err => {
			console.error( err );
		})
	}
	selectedCve(o) {
		const cve = o?.value ?? o;
		if ( ! cve ) {
			const ns = { cveDialog: false, cve: false };
			const cves = this.state.cves;
			if ( Array.isArray(cves) ) {
				for ( const cve of cves ) {
					delete cve.selected;
				}
				ns.cves = cves;
			}
			this.selectedCve(ns);
			return;
		}
		const ns = { cve: cve };
		const cves = this.state.cves;
		if ( Array.isArray(cves) ) {
			for ( const c of cves ) {
				if (c.value !== cve) delete c.selected;
			}
			ns.cves = cves;
		}
		if ( o.graph || this.state.cart[cve]) {
			const c = o.graph ? o : this.state.cart[cve];
			appLib.api('cve/get', { id: cve }).then( x => {
				const metric = ((x.metrics||{})[ Object.keys(x.metrics||{}).sort().pop()||'x' ]||[])[0]?.cvssData||{};
				ns.cveDialog = {
					cve: cve,
					details: {finalScore: c.score ?? c?.src?.finalScore },
					metric: metric,
					risorsa: c.risorsa,
					risorsaLabel: c.risorsaLabel,
					subject: c.subject,
					subjectLabel: c.subjectLabel,
				};
				this.setState(ns);
			});
		} else {
			appLib.api('cve/list-by-year', { cve: cve }).then( x => {
				ns.cveDialog = (x?.list||[])[0]?.version ? {
					cve: cve,
					details: (this.state.cves||[]).find( c => c.value === cve )?.src,
					metric: (x?.list||[])[0],
					risorsa: this.state.selectedRisorsa,
					risorsaLabel: this.state.risorse.find( r => r.value === this.state.selectedRisorsa )?.label,
					subject: this.state.selectedSubject,
					subjectLabel: this.state.subjects.find( c => c.value === this.state.selectedSubject)?.label,
				} : false;
				this.setState( ns );
			});
		}
	}
	openSelector() {
		if ( this.state.triggersUc2 ) {
			this.setState({ useGraphicSelector: true })
			return;
		}
		appLib.api("perimetri/list-triggers-uc2", { id:this.props.peri}).then( res => {
			this.setState( { triggersUc2 : res, useGraphicSelector: true } );
		}).catch( err => { console.error( err ); } );
	}
	add2cart( scope ) {
		const cart = this.state.cart || {}
		const cve = this.state.cve;
		if ( scope ) {
			const d = this.state.cveDialog;
			if ( ! cart[cve] ) cart[cve] = { new: true };
			cart[cve].scope = scope;
			cart[cve].cve = cve;
			cart[cve].risorsa = d.risorsa;
			cart[cve].risorsaLabel = d.risorsaLabel;
			cart[cve].subject = d.subject;
			cart[cve].subjectLabel = d.subjectLabel;
			cart[cve].score = d.details.finalScore;
		} else {
			delete cart[ cve ];
		}
		const inCart = {};
		Object.values( cart ).forEach( c => {
			inCart[ c.risorsa ] = true;
		});
		this.setState( { inCart: inCart, cart: cart, cveDialog: false, update: Date.now(), useGraphicSelector: false }, ()=>{
			this.selectedRisorsa( this.state.selectedRisorsa );
			this.props.changed(this.state.cart);
		});
	}
	render() {
		return (
			<div
				className={"panel-content "+prefix}
				style={{maxWidth:"min(100vw, 100%, 1600px)",margin:"0 auto"}}
			>
				<div className={"limited"}>
					<MyAccordion title={"Use case 2"}>
						Nel perimetro vengono esposte le Risorse (o se possibile i SistemiInformativi, raggruppandone le Risorse),
						per queste vengono indicate le CVE a cui potrebbero essere soggette in ordine di fattore di rischio.<br />
						Il fattore di rischio viene calcolato combinando lo score dell’impatto con le modalità di attacco (locale, LAN o rete)
						in relazione all’esposizione delle Risorse tramite una Rete.<br />
						Vengono scelte le CVE per cui si vuole simulare l'exploit, l'impatto conseguente determina il trigger di partenza.
					</MyAccordion>
					{  (! this.props.did?.run) && (
						<div className={"mt-2 mb-2 text-end"}>
							<Button
								color={"success"}
								className={"btn-icon"}
								onClick={ this.openSelector }
							>
								<b>
									<TextLabel value={"Graphic selector"} />
								</b>
								<i>
									<AppPalleIcon />
								</i>
							</Button>
						</div>
					)}
				</div>
				{ (! this.props.did?.run) && (
					<>
						<MultiColumnBrowserContainer
							style={{height: 'min(50vh,320px)',resize:'unset'}}
						>
							<MultiColumnBrowserColumn
								key={ 'subjects'+(this.state.subjects ?? []).length }
								options={ this.state.subjects ?? [] }
								title={ <TextLabel value={"Main subjects"} /> }
								onClick={ this.fetchRisorse }
								width={"33.334%"}
								filter={Glob.label('Filter')}
							/>
							{ (!! this.state.selectedSubject ) && (
								<MultiColumnBrowserColumn
									key={ this.state.selectedSubject }
									title={ <TextLabel value={"Resources"} /> }
									options={ this.state.risorse ?? [] }
									onClick={ this.selectedRisorsa }
									width={"33.334%"}
									filter={Glob.label('Filter')}
								/>
							)}
							{ this.state.selectedRisorsa && (
								<MultiColumnBrowserColumn
									key={ this.state.selectedRisorsa }
									title={ <TextLabel value={"CVE"} /> }
									options={ this.state.cves ?? [] }
									onClick={ this.selectedCve }
									width={"33.334%"}
									filter={Glob.label('Filter')}
								/>
							)}
						</MultiColumnBrowserContainer>
						{ (!!this.state.cveDialog ) && (
							<SimulationFlowSettings2Modal
								option={ this.state.cveDialog }
								cve={ this.state.cve }
								selected={ this.state.cart[this.state.cve]?.scope }
								metric={ this.state.cveDialog.metric }
								close={ ()=>{ this.selectedCve() }}
								save={ this.add2cart }
							/>
						)}
					</>
				)}
				<MyCart
					key={ 'cart'+this.state.update }
					data={ this.state.cart }
					onClick={ this.props.did?.run ? undefined : this.selectedCve }
				/>
				{ this.state.useGraphicSelector && (
					<FullScreenModal
						title={ <>{ this.props.simul.fake ? <AppSynthDataIcon /> : <AppPerimeterIcon /> } <span>{this.props.simul.info.periname}</span></> }
						toggle={ ()=>{ this.setState({ useGraphicSelector: false } ) }}
					>
						<PeriGraphic
							id={ this.props.simul.info.peri }
							highlighted={ Object.keys(this.state.inCart || {}) }
							onNodeClick={ async (node,pc) => {
								const nd = node.data();
								if ( ! this.state.triggersUc2[nd.id ]) return false;
								await this.selectCve(nd.id);
								return false;
							}}
						/>
					</FullScreenModal>
				)}
				{ (!! this.state.cvesModalSelector) && (
					<SimulationFlowSettings2CvesModal
						cves={ this.state.cvesModal }
						source={ this.state.cvesModalSource }
						peri={ this.props.peri }
						close={ ()=>{ this.setState({cvesModalSelector: false, cvesModal: [] })}}
						save={ id => {
							this.setState({cvesModalSelector: false, cvesModal: [] }, ()=>{
								this.selectedCve(id);
							})
						} }
					/>
				)}
			</div>
		)
	}
}

export default SimulationFlowSettings2;